jQuery( function ($) {

  if ( typeof gform != 'object' ) { return }

  gform.addFilter( 'gform_datepicker_options_pre_init', function( optionsObj, formId, fieldId ) {
    const $input = jQuery('#input_' + formId + '_' + fieldId);
    if ($input.data( 'no-past' ) ) {
      optionsObj.minDate = 0;
    }
    return optionsObj;
  });

})